import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useLoaderData } from "react-router-dom";
import { getAllClientAccounts } from "API/swesum";
import ClientAccountsTableContainer from "Components/Account/ClientAccountsTableContainer";

export async function loader() {
  const clientAccounts = await getAllClientAccounts();
  return { clientAccounts };
}

export default function ClientsAccounts() {
  const navigate = useNavigate();
  const [clientAccounts, setClientAccounts] = useState([]);

  useEffect(() => {
    const asyncFetchClientAccounts = async () => {
      const tmpClientAccounts = await getAllClientAccounts();
      setClientAccounts(tmpClientAccounts);
    };
    asyncFetchClientAccounts();
  }, []);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Klientkonton</Typography>
              <Button
                onClick={() => navigate("create")}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                SKAPA NY
              </Button>
            </Box>
            <ClientAccountsTableContainer accounts={clientAccounts} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
